import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { enrollmentColumnDefs, defaultColDef } from './definitions-config';
import { Dialog, DialogContentText } from '@material-ui/core';
import { getFullName } from '../../../utils';
import SearchIcon from '../../../icons/SearchIcon';

function EnrollmentTable({ rowData, show, dialogOpen, name}) {
  const [searchData, setSearchData] = React.useState([]);

  const searchEnrolments = (e) => {
    if (e.target.value === '') {
      return setSearchData([]);
    }
    const value = e?.target?.value?.toLowerCase();
    const searchValue = rowData.filter((row) => {
      const name = getFullName(row?.referredUserDetail)?.toLowerCase() || '';
      const email = row?.referredUserDetail?.email || '';
      if (name?.includes(value) || email?.includes(value)) {
        return true;
      }
      return false;
    });
    setSearchData(searchValue);
  };

  const data = searchData.length > 0 ? searchData : rowData;

  return (
    <Dialog
      onClose={() => show(false)}
      aria-labelledby='simple-dialog-title'
      open={dialogOpen}
      className='w-full'
      fullWidth={true}
    >
      <div className='px-6 pt-6 pb-2'>
        <div className='flex pb-4 text-xl'>
          <span className='mr-2'>{`${name}'s`} </span>
          <span className='font-semibold'>referral Enrollments</span>
          {/* <span></span> */}
        </div>

        <DialogContentText>
          {rowData.length > 0 ? (
            <div>
              <div className='mb-4'>
                <SearchIcon iconStyle='w-4 h-4 absolute mt-2 ml-3' />
                <input
                  className='rounded-sm w-full p-1 search-icon-refer-earn pl-10'
                  style={{
                    border: '1px solid #EBEBEB',
                    backgroundColor: '#EBEBEB',
                  }}
                  placeholder='Search ...'
                  onChange={searchEnrolments}
                />
              </div>
              <div
                style={{ height: '60vh', maxHeight: '60vh' }}
                className='mt-4 ag-theme-alpine'
              >
                <AgGridReact
                  rowData={data}
                  columnDefs={enrollmentColumnDefs}
                  defaultColDef={defaultColDef}
                  tooltipShowDelay={0}
                  tooltipHideDelay={2000}
                  rowHeight={50}
                />
              </div>
            </div>
          ) : (
            <div>No Enrollments</div>
          )}
        </DialogContentText>
      </div>
    </Dialog>
  );
}

export default EnrollmentTable;
